import axios from "axios";
import { STORE_BASE_URL } from "../BaseURL";
import getHeaders from "../../constants/headers";

export const getGarmentStock = data => {
    return axios({
      method: 'post',
      url: STORE_BASE_URL + '/store/api/secure/v1/report/garment-report',
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };
   